exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dashboard-carousel-header__container{display:flex;justify-content:space-between;width:100%;margin-bottom:24px}.dashboard-carousel-header__title{font-size:24px;line-height:48px;font-weight:500}.dashboard-carousel-header__link{font-size:16px;line-height:24px;font-weight:inherit;color:#3fa2f7;align-self:center}.dashboard-carousel-header__link:hover{color:#3fa2f7}@media(pointer: coarse){.dashboard-carousel-header__link{display:none}}", ""]);
// Exports
exports.locals = {
	"medium": "768px",
	"large": "1024px",
	"xlarge": "1440px"
};